export default __webpack_public_path__ + "static/media/multi-chevron.9c23aaf5.svg";